// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IAddress } from './iAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ISite {
    'contactName'?: string;
    'description'?: string;
    'faxNumber'?: string;
    'id'?: string;
    'name': string;
    'phoneNumber'?: string;
    'type'?: string;
    'address'?: IAddress | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ISite>> = [
        {
            "name":     "contactName",
            "baseName": "contactName",
            "type":     "string"
        },
        {
            "name":     "description",
            "baseName": "description",
            "type":     "string"
        },
        {
            "name":     "faxNumber",
            "baseName": "faxNumber",
            "type":     "string"
        },
        {
            "name":     "id",
            "baseName": "id",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "IAddress"
        },
    ];

    static getAttributeTypeMap() {
        return ISite.attributeTypeMap;
    }
}
